import gql from 'graphql-tag'

// for S2 compositions
export const GET_CURRENT_COMPOSITION = gql`
  query {
    composition @client
  }
`

export const SET_CURRENT_COMPOSITION = gql`
  mutation setComposition($composition: String) {
    setComposition(composition: $composition) @client
  }
`

export const SET_CURRENT_NOTETYPE_ID = gql`
  mutation setCurrentNotetypeId($id: String) {
    setCurrentNotetypeId(id: $id) @client
  }
`

export const GET_CURRENT_NOTETYPE_ID = gql`
  query {
    currentNotetypeId @client
  }
`

export const GET_NOTE_CREATED_RESPONSE = gql`
  query {
    noteCreatedResponse @client {
      isPending
      composition
      error
      id
    }
  }
`

export const SET_NOTE_CREATED_RESPONSE = gql`
  mutation setNoteCreatedResponse($isPending: Boolean, $composition: String, $error: Boolean, $id: String) {
    setNoteCreatedResponse(isPending: $isPending, composition: $composition, error: $error, id: $id) @client
  }
`

export const GET_NOTE_PULL_RESPONSE = gql`
  query {
    notePullResponse @client {
      isPending
    }
  }
`

export const SET_NOTE_PULL_RESPONSE = gql`
  mutation setNotePullResponse($isPending: Boolean) {
    setNotePullResponse(isPending: $isPending) @client
  }
`

export const SET_NOTE_CREATED_PENDING = gql`
  mutation setNoteCreatedPending($isPending: Boolean) {
    setNoteCreatedResponse(isPending: $isPending) @client
  }
`

export const SET_NEW_COMPOSITION = gql`
  mutation setNewComposition($composition: String) {
    setNewComposition(newComposition: $composition) @client
  }
`

export const GET_NEW_COMPOSITION = gql`
  query {
    newComposition @client
  }
`

export const GET_SECTIONS_TO_UPDATE = gql`
  query {
    sectionsToUpdate @client {
      id
      name,
      status
      content
      cursorPosition
      cursorPositionName
    }
  }
`

export const SET_SECTIONS_TO_UPDATE = gql`
  mutation setSectionsToUpdate($sections: [SectionToUpdate]) {
    setSectionsToUpdate(sectionsToUpdate: $sections) @client
  }
`

export const REMOVE_SECTION_TO_UPDATE = gql`
  mutation removeSectionToUpdate($id: ID!) {
    removeSectionToUpdate(sectionIdToRemove: $id) @client
  }
`

export const CLEAR_SECTIONS_TO_UPDATE = gql`
  mutation clearSectionsToUpdate($reason: String) {
    clearSectionsToUpdate(reason: $reason) @client
  }
`

export const GET_COMP_BEING_CREATED = gql`
  query {
    compBeingCreated @client
  }
`

export const SET_COMP_BEING_CREATED = gql`
  mutation setCompBeingCreated($compBeingCreated: Boolean!) {
    setCompBeingCreated(compBeingCreated: $compBeingCreated) @client
  }
`

export const GET_COMP_BEING_DELETED = gql`
  query {
    compBeingDeleted @client
  }
`

export const SET_COMP_BEING_DELETED = gql`
  mutation setCompBeingDeleted($compBeingDeleted: Boolean!) {
    setCompBeingDeleted(compBeingDeleted: $compBeingDeleted) @client
  }
`

export const SET_SUBMISSION_STATUS = gql`
  mutation setSubmissionStatus($status: EMRSubmissionStatus!) {
    setSubmissionStatus(status: $status) @client
  }
`

export const CLEAR_SUBMISSION_STATUS = gql`
  mutation clearSubmissionStatus {
    clearSubmissionStatus @client
  }
`

export const GET_SUBMISSION_STATUS = gql`
  query {
    submissionStatus @client {
      warning {
        type,
        message
      },
      finalDestination
    }
  }
`

export const SET_ADD_PB_SECTION = gql`
  mutation setAddPbSection {
    setAddPbSection @client
  }
`

export const CLEAR_ADD_PB_SECTION = gql`
  mutation clearAddPbSection {
    clearAddPbSection @client
  }
`

export const GET_ADD_PB_SECTION = gql`
  query {
   addPbSection @client
  }
`

export const SET_DELETE_COMP_RES = gql`
  mutation setDeleteCompRes($status: Boolean) {
    setDeleteCompRes(status: $status) @client
  }
`

export const GET_DELETE_COMP_RES = gql`
  query {
    deleteCompResponse @client {
      isCompDeleted
      error
    }
  }
`

export const CLEAR_KEYBOARD_MODE = gql`
  mutation clearKeyboardMode {
    clearKeyboardMode @client
  }
`

export const SET_KEYBOARD_MODE = gql`
  mutation setKeyboardMode {
    setKeyboardMode @client
  }
`

export const GET_KEYBOARD_MODE = gql`
  query {
    keyboardMode @client
  }
`

export const SET_SECTION_BEING_DELETED = gql`
  mutation setSectionBeingDeleted($id: String) {
    setSectionBeingDeleted(id: $id) @client
  }
`

export const GET_SECTION_BEING_DELETED = gql`
  query {
    sectionBeingDeleted @client {
      id
    }
  }
`
